import { render, staticRenderFns } from "./app-page-exp.vue?vue&type=template&id=b05ae564&"
import script from "./app-page-exp.vue?vue&type=script&lang=ts&"
export * from "./app-page-exp.vue?vue&type=script&lang=ts&"
import style0 from "./app-page-exp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports